/**
 * The journal's eight colours (#464).
 *
 * A FIXED PALETTE, NOT A USER-DEFINED LIST. A colour list would need a
 * management screen and a seed -- an empty colour picker on first use is
 * a dead end, so every account would need default rows written at signup
 * or lazily, and both are a migration problem forever. The ask was
 * visual grouping and filtering; a palette gives both immediately.
 *
 * Meaning lives in TAGS, which are named and free-form. Colour is the
 * quick visual bucket you scan down a list for.
 *
 * NAMED FOR WHAT THEY ARE, not what they mean -- 'amber', not
 * 'important'. What a colour means is the user's own, and differs per
 * person; naming meanings here would be a product decision nobody asked
 * for, and a wrong one for most people.
 *
 * Eight is the ceiling on purpose. Past that they stop being
 * distinguishable at a glance, which is the only job they have.
 *
 * THESE NAMES ARE A COPY. CK_Journal_colour in V118 carries the same
 * eight and services/journal.py's _PALETTE carries them a third time.
 * A colour added here and nowhere else is a swatch that 400s on save;
 * added to the constraint and not here, it is a colour nobody can pick.
 * journalColours.test.js reads the migration and asserts they match.
 */

export const JOURNAL_COLOURS = [
  { key: "amber", label: "Amber", css: "#d97706" },
  { key: "green", label: "Green", css: "#15803d" },
  { key: "blue", label: "Blue", css: "#1d4ed8" },
  { key: "purple", label: "Purple", css: "#7e22ce" },
  { key: "red", label: "Red", css: "#b91c1c" },
  { key: "teal", label: "Teal", css: "#0f766e" },
  { key: "grey", label: "Grey", css: "#4b5563" },
  { key: "pink", label: "Pink", css: "#be185d" },
];

export const colourOf = (key) => JOURNAL_COLOURS.find((c) => c.key === key) || null;
